// Some TV browsers disable storage or exhaust their small quota. Persistence
// must never stop the app from rendering or playing audio.
export const safeStorage = {
  getItem(key: string): string | null {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  setItem(key: string, value: string): void {
    try { localStorage.setItem(key, value); } catch { /* Keep the current UI state. */ }
  },
};
